// extracted by css-extract-rspack-plugin
module.exports =  {"weatherHourlyForecast":"bEDUg","hourlyForcastList":"XJmUb","weatherHourlyWrapper":"_Rgn1","weatherViewAction":"UJxfF","noblurBg":"IILXP","actnBlock":"lZHUW"};